import { EnderecoDTO } from "./enderecoDTO";

export class OriginadorDTO {
  public id!: string | null;
  public nome!: string;
  public razaoSocial!: string;
  public email!: string;
  public enderecoDTO!: EnderecoDTO | undefined;
  public telefoneComercial!: string;
  public telefoneCelular!: string;
  public codigoExterno!: string;
  public idMatriz!: string;
  public corPrincipal!: string;
  public corSecundaria!: string;
  public corTexto!: string;
  public corCabecalho!: string;
  public corTabela!: string;
  public apiKey!: string;
  public logoBase64!: string | null; 
}